import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import { IntegrationSummaryCard } from '@feathr/components';

import { getConnectedBy } from './RaisersEdgeConnectionDetails.utils';

interface IProps {
  integration: BlackbaudRaisersEdgeIntegration;
  /** Disconnects the integration. Rejects on failure, so the confirm modal stays open. */
  onDisconnect: () => Promise<void>;
  /** Disables Disconnect with this reason, e.g. while the page saves. */
  disabledReason?: string;
}

function RaisersEdgeConnectionDetails({
  disabledReason,
  integration,
  onDisconnect,
}: Readonly<IProps>): JSX.Element {
  return (
    <IntegrationSummaryCard
      connectedBy={getConnectedBy(integration.get('authenticated_user'))}
      connectedOn={integration.get('date_created') ?? null}
      disconnectDisabledReason={disabledReason}
      name={'raisers-edge-connection-details'}
      onDisconnect={onDisconnect}
    />
  );
}

export default observer(RaisersEdgeConnectionDetails);
